import { ApiProperty } from "@nestjs/swagger";
import { BomPackingItemsDto } from "./packing-materials.dto";

export class CreateBomDTO{
    @ApiProperty()
    bomItems:BomPackingItemsDto[];
    @ApiProperty()
    deletedBomItems:number[];
}